/* global $ */
// form-styling

// select elements tweaks
const $selectElements = $('select')

if ($selectElements.length > 0) {
  $selectElements.wrap('<div class="form__select-wrapper"></div>')
  $selectElements.after('<div class="form__select-arrow"></div>')
}

// checkbox and radio elements tweaks
const $labels = $('input[type=checkbox]~label, input[type=radio]~label')

if ($labels.length > 0) {
  $labels.wrapInner('<span></span>')
}

export function toggleIfChecked (checkbox, elem) {
  if (checkbox.checked) {
    elem.classList.remove('hide')
  } else {
    elem.classList.add('hide')
  }
}

export function toggleIfRbSelected (elemId, options) {
  const elem = document.getElementById(elemId)

  if (options.true.checked) {
    elem.classList.add('hide')
  } else if (options.false.checked) {
    elem.classList.remove('hide')
  }
}

export function setupBoolRbs (elemId, optionTrueId, optionFalseId, func = toggleIfRbSelected, args = []) {
  const options = {
    true: document.getElementById(optionTrueId),
    false: document.getElementById(optionFalseId)
  }

  for (const option in options) {
    options[option].addEventListener('change', () => func(elemId, options, ...args))
  }

  func(elemId, options, ...args)
  return options
}

export function saveCheckboxValuesToTextfield (checkboxes, textField) {
  textField.value = checkboxes
    .filter(cb => cb.checked)
    .map(cb => cb.value)
    .join(', ')
}
